






import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@components/LoadingIndicator'
import OrganizerDashboardView from '@ui/Dashboard/Views/Organizer/OrganizerDashboardView'

settings =
  name: 'OrganizerDashboardShow'

  vue:
    components: {
      LoadingIndicator,
      OrganizerDashboardView,
    }

    computed:
      organizer: ->
        @$store.member.organizer

export default VueOptions.vue settings
